import React from 'react'
import Container from './container'
import { truncate } from 'lodash'
import Link from '../components/link'
import Img from 'gatsby-image'
import Markdown from 'react-markdown'

import '../styles/short-studios.css'

function StudioProjectEntry({ index, title, description, url, tech, banner, date, titleColor, btnStyle = 'darkBlue', contentPadding }) {
  return (
    <div className="studio-project-card">
      {banner ? <Img
        className="studio-project-banner-img"
        imgStyle={{ objectFit: 'cover' }}
        fluid={banner.childImageSharp.fluid}
        alt={title}
      /> : <img
        className="studio-project-banner-img-native"
        alt={tech}
      />}
      <div className="studio-project-content-layer">
        <div style={{ padding: contentPadding }} className="studio-project-content-inner">
          <h1 style={{ color: titleColor }} className="studio-project-title">{title}</h1>
          {description && (
            <div
              className="studio-project-description"
              style={{ color: titleColor }}>
              <Markdown
              >
                {description}
              </Markdown>
            </div>
          )}
          <Link
            to={url}
            className={`studio-project-link btn-${btnStyle === 'darkBlue' ? 'dark-blue' : 'light-yellow'}`}
          >
            查看&nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9"><polyline fill="none" stroke="currentColor" strokeWidth="2" points="57 18 60.5 21.5 57 25" transform="translate(-56 -17)"></polyline></svg>
          </Link>
        </div>
      </div>
    </div>
  )
}



export default function ShortTalks({ allStudios }) {

  console.log(allStudios)

  return (
    <Container
      className="short-studio-wrap"
    >
      {allStudios.edges.slice(0, 8).map(({ node: studioProject }, index) => (
        <StudioProjectEntry
          index={index}
          key={studioProject.id}
          title={studioProject.frontmatter.title}
          description={truncate(studioProject.frontmatter.description, {
            length: 190,
          })}
          contentPadding={studioProject.frontmatter.contentPadding}
          titleColor={studioProject.frontmatter.titleColor}
          btnStyle={studioProject.frontmatter.btnStyle}
          date={studioProject.frontmatter.date}
          banner={studioProject.frontmatter.banner}
          url={
            studioProject.fields.slug
              ? studioProject.fields.slug
              : `/studio/${studioProject.frontmatter.slug}`
          }
          tech={studioProject.frontmatter.tech}
        />
      ))}
    </Container>
  )
}
